import { render } from "./AddFacilityAddress.vue?vue&type=template&id=5b5896d2&scoped=true&ts=true"
import script from "./AddFacilityAddress.vue?vue&type=script&lang=ts"
export * from "./AddFacilityAddress.vue?vue&type=script&lang=ts"

import "./AddFacilityAddress.vue?vue&type=style&index=0&id=5b5896d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5896d2"]])

export default __exports__